import { render, staticRenderFns } from "./DynamicGroupUpdate.vue?vue&type=template&id=a09631aa&"
import script from "./DynamicGroupUpdate.vue?vue&type=script&lang=ts&"
export * from "./DynamicGroupUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports